module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAQAAAC1+jfqAAAACXBIWXMAAA3XAAAN1wFCKJt4AAAAB3RJTUUH4ggCDhEdN2DxoAAAAONJREFUKM+l0E8rRAEUhvHnXHemJkoJ5UPYjSR7C1aab2DlK/gStmpiY2ExK0qyM5FkpwxbpUZNFuRfM7j3sWB3ryy8m7M4v95TJ5xjkQF7cUl53DU3c8OR8n3KOEEwRuU30OSFPtvxUA7CYSbJ6MXAClXAeLPKKPAcfUhZZRpou8MCDYKu+ywxC3RsxRkeqtq05pqZ2vPID1Vzj51JCkcnqHPFNTnBPI0ieGedZVZoAwn1IujSips455QcmCpreALgkQyoFYE/M/9+Q8If+T9IOeAWOOGTCzYJ7ngFoMMWQ9x/AW9NW53TjeC/AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/Menu/assets/img/linkedin_logo.png
// module id = 564
// module chunks = 79611799117203